export const Config = {
    url: process.env.REACT_APP_BASE_URLOPEN,
    urlOpen: process.env.REACT_APP_BASE_URLOPEN, 
}